import { useEffect, useState } from "react";
import { cache_clear_ALL, getTotalCacheSize } from "../js/CacheFunctions";
import { Divider, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { useSnackbar } from "src/context/SnackbarContext";

export default function CacheSize({ text = "cache", style = {} }) {
  const [cacheSize, setCacheSize] = useState(0);
  const { openSnackbar } = useSnackbar();

  // Update cache size every 5 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      const a = getTotalCacheSize();
      setCacheSize(a);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const tooltipStyles = { display: "flex", justifyContent: "space-between", gap: 4 };

  const TooltipText = (
    <>
      <div style={tooltipStyles}>
        <span>
          <b>
            <u>CACHE</u>
          </b>
        </span>
        <span></span>
      </div>
      <div style={tooltipStyles}>
        <span>Caches</span>
        <span>{cacheSize.totalCaches}</span>
      </div>
      <div style={tooltipStyles}>
        <span>Items</span>
        <span>{cacheSize.totalItems}</span>
      </div>
      <div style={tooltipStyles}>
        <span>Hits</span>
        <span>{cacheSize.totalHits}</span>
      </div>
      <div style={tooltipStyles}>
        <span>Misses</span>
        <span>{cacheSize.totalMisses}</span>
      </div>
      <Divider />
      <div style={tooltipStyles}>
        <span>Usage ratio</span>
        <span>
          {cacheSize.totalItems > 0 ? (cacheSize.totalHits / cacheSize.totalItems).toFixed(2) : 0}
        </span>
      </div>
    </>
  );

  const handleClick = () => {
    cache_clear_ALL();
    const a = getTotalCacheSize();
    setCacheSize(a);
    openSnackbar({
      open: true,
      message: "",
      title: "Välimuisti tyhjennetty",
      severity: "success",
    });
  };

  return (
    <div onClick={handleClick}>
      <Tooltip title={TooltipText} placement="top" disableInteractive>
        {displayCacheSize()}
      </Tooltip>
    </div>
  );

  function displayCacheSize() {
    return (
      <div style={{ fontSize: "10px", opacity: 0.7, cursor: "default", ...style }}>
        {text}
        {cacheSize.totalItems}
      </div>
    );
  }
}

CacheSize.propTypes = {
  text: PropTypes.string,
  style: PropTypes.object,
};
